module.exports = __webpack_public_path__ + "qr2.36f494e2.png";